export default {
  state: () => ({
    files: {},
    activeFile: ''
  })
}



// WEBPACK FOOTER //
// ./src/app/store/files/config.js